import { useEffect } from "react";
import {
  offFeatureListener,
  onFeatureListener,
  selectFeature,
} from "../functions/interactivity.map.js";
import { pageNames } from "../../../../reduxStore/reducers/main.js";

/** Map Interactivity Funktionstrigger bei bestimmenten StateChanges */
export default function useMapInteractivity(props) {
  useEffect(() => {
    // Kümmert sich quasi nur darum das currentFeature an- und abzuzeigen
    if (!props.mapLoaded) return;
    // Feature auf der Map selecten und hinfliegen
    if (props.currentMapPage === pageNames.info) {
      selectFeature(props.currentFeature?.selectedFeature, true, {
        padding: props.mapPadding,
      });
    } else {
      selectFeature(null);
    }

    // ChildFeature auf der map ausblenden (feature-state -> selected)
    if (!props.currentChildrenFeatures) return;
    props.currentChildrenFeatures.forEach((cF) => {
      if (cF.id === props.currentFeature.id) {
        selectFeature(cF, false, null, true);
      }
    });
  }, [props.mapLoaded, props.currentFeature, props.mapPadding]);

  useEffect(() => {
    // Wenn die Seite eine andere als Info ist, sollte es nicht möglich sein
    // das currentFeature durch MapKlick aufzuheben
    if (!props.mapLoaded) return;
    if (props.currentMapPage !== pageNames.info) {
      // mapclicks und alle normalen interaktionen werden deaktiviert
      offFeatureListener();
    } else {
      onFeatureListener();
    }
  }, [props.currentMapPage, props.mapLoaded, props.currentRoute]);
}
